import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'dialog-logout-confirm',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './dialog-logout-confirm.component.html',
  styleUrls: ['./dialog-logout-confirm.component.scss']
})
export class DialogLogoutConfirmComponent implements AfterViewInit {

  @ViewChild('btnNo') btnNo!: ElementRef;

  constructor(
    // private readonly _dialogDeleteConfirm: DialogDeleteConfirmService,
    private readonly _ref: DynamicDialogRef
  ) {

    // _dialogDeleteConfirm.subj$.subscribe(x=>{
    //   this.showConfirm();
    // })

  }
  ngAfterViewInit(): void {
    //experimental
    setTimeout(() => {
      this.btnNo.nativeElement.blur();
    }, 10);
  }

  onNoClicked() {
    this._ref.close(false);
  }

  onConfirmClicked() {
    this._ref.close(true);
  }
}
